var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKnowledgeConfidence(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.15,101.06c5.24-12.3,19.28-20.34,33.64-20.34a34.7,34.7,0,0,1,31.12,50s-10.56,22.25-6.46,48.21h-41L93,164.63s-.42-3.54-7.29-3.54-9.17-1.67-10-10.42-.21-10.84-5.21-12.3-5.42-3.54-1.25-9.59,5.63-7.71,5.42-11.67S75.07,106,77.15,101.06Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 109.35,
    y1: 57.21,
    x2: 109.35,
    y2: 38.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 54.97,
    y1: 111.59,
    x2: 35.96,
    y2: 111.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 182.74,
    y1: 111.59,
    x2: 163.72,
    y2: 111.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 147.8,
    y1: 73.14,
    x2: 161.24,
    y2: 59.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 70.9,
    y1: 73.14,
    x2: 57.45,
    y2: 59.69
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeConfidence);
export default __webpack_public_path__ + "static/media/KNOWLEDGE_CONFIDENCE.931458e3d5d29a22a4b53d960afb9637.svg";
export { ForwardRef as ReactComponent };